import React, { useState } from 'react';
import styles from './styles';
import { motion } from 'framer-motion';
import { useNavigate } from '@tanstack/react-router'; // or useRouter for Next.js

const ApplicationForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    portfolio: '',
    customRole: '',
    message: '',
    selectedRole: '',
  });

  const [buttonHover, setButtonHover] = useState(false);
  const navigate = useNavigate(); // or useRouter() for Next.js

  const listedRoles = ['Software Engineer', 'UX Designer', 'Product Manager'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((fd) => ({ ...fd, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.selectedRole && !formData.customRole) {
      const slug = formData.selectedRole.toLowerCase().replace(/\s+/g, '-');
      navigate(`/talent/${slug}`);
    } else {
      onSubmit(); // trigger thank-you message
    }
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      noValidate
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <label htmlFor="name" style={styles.label}>Sacred Name</label>
      <input style={styles.input} type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your full name" required />

      <label htmlFor="email" style={styles.label}>Sacred Connection</label>
      <input style={styles.input} type="email" name="email" value={formData.email} onChange={handleChange} placeholder="your.email@example.com" required />

      <label htmlFor="portfolio" style={styles.label}>Your Sacred Work</label>
      <input style={styles.input} type="url" name="portfolio" value={formData.portfolio} onChange={handleChange} placeholder="Portfolio, LinkedIn, or sacred space" />

      <label style={styles.label}>Choose Your Sacred Path</label>
      <select
        style={styles.input}
        name="selectedRole"
        value={formData.selectedRole}
        onChange={handleChange}
      >
        <option value="">-- Propose your own sacred role --</option>
        {listedRoles.map(role => (
          <option key={role} value={role}>{role}</option>
        ))}
      </select>

      {!formData.selectedRole && (
        <>
          <label htmlFor="customRole" style={styles.label}>Your Sacred Calling</label>
          <input
            style={styles.input}
            type="text"
            name="customRole"
            value={formData.customRole}
            onChange={handleChange}
            placeholder="e.g. Conscious Technologist, Sacred Designer..."
          />
        </>
      )}

      <label htmlFor="message" style={styles.label}>Why do you feel called to serve with us?</label>
      <textarea style={styles.textarea} name="message" value={formData.message} onChange={handleChange} placeholder="Share your vision and how you can contribute to our sacred mission..." required />

      <motion.button
        type="submit"
        style={{ ...styles.button, ...(buttonHover ? styles.buttonHover : {}) }}
        onMouseEnter={() => setButtonHover(true)}
        onMouseLeave={() => setButtonHover(false)}
        whileTap={{ scale: 0.97 }}
        whileHover={{ scale: 1.02 }}
        className="w-full bg-silver/10 text-silver border border-silver/30 rounded-xl py-4 font-light hover:bg-silver/20 hover:border-silver/50 transition-all duration-500"
      >
        Submit Sacred Application
      </motion.button>
    </motion.form>
  );
};

export default ApplicationForm;
